(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('threedsBridge', function($http, $window, $rootScope, analytics) {
    const hidden = '<input type="hidden" name="{0}" value="{1}" />';
    return {
        restrict: 'E',
        scope: true,
        template: '<iframe id="threeframe" name="threeframe" frameBorder="0" width="100%" height="550px"></iframe>',
        link(scope) {
            // var frame = angular.element('#threeframe');

            /*function back() {
                scope.$emit('3DSValidationCancelled');
                $($window).off('popstate', back);
            }*/

            //evil global used to obtain the results from 3ds validation. There's not really any other way.
            $window.threed3Callback = function(paRes, prePaymentId, md, paymentId) {
                if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                    paRes = paRes.replaceAll('^', '');
                    if (paRes !== 'CANCELLED') {
                        scope.$emit('3DSValidationComplete', {
                            paRes,
                            prePaymentId,
                            md,
                            paymentId
                        });
                    } else {
                        document.querySelector('.threeds-wrapper-new .close').click();
                    }
                } else {
                    scope.$emit('3DSValidationComplete', {
                        paRes,
                        prePaymentId,
                        md,
                        paymentId
                    });
                }
            };

            function cpGValidationComplete(response) {
                if (!response) {
                    return;
                }
                const paRes = response && response.paRes;
                const prePaymentId = response && response.prePaymentId;
                if (!paRes && !prePaymentId) {
                    return;
                }
                const md = '';
                const paymentId = '';
                scope.$emit('CPGValidationComplete', {
                    paRes,
                    prePaymentId,
                    md,
                    paymentId
                });
            }

            scope.$on('3DSValidationFinished', function(ev, isSuccess) {
                if (!_.isEmpty(scope.mixpanelData)) {
                    analytics.track('mixpanel', (isSuccess ? '3DS Finished' : '3DS Failed'), scope.mixpanelData);
                }
            });

            $rootScope.$on('cpgStatusResponse', function(ev, request) {
                cpGValidationComplete(request);
            });

            function getAuth(domainId, cardTypeId, currencyCode, orderCode) {
                try {

                    if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                        cardTypeId = 370;

                        let ss = sessionStorage.getItem('isBetaDomain');
                        let url = window.location.href;
                        let isMyb = false;

                        if (url.match('\\pay-balance/\\w+')) {
                            isMyb = true;
                        }
                        if (ss && isMyb) {
                            domainId = 107;
                        }

                        if (TRPCONFIG.Domain2.CPGIframeCloseBackButtonBug) {
                            let CPGIframeIntvlTimeout = TRPCONFIG.Domain2.CPGIframeIntvlTimeout;
                            let CPGNoOfCallsForIntervalStart = TRPCONFIG.Domain2.CPGNoOfCallsForIntervalStart;
                            let CPGNoOfCallsForIntervalPaymentFound = TRPCONFIG.Domain2.CPGNoOfCallsForIntervalPaymentFound;
                            let CPGNoOfCallsForOTPerror = TRPCONFIG.Domain2.CPGNoOfCallsForOTPerror;
                            let CPGdisplayIframeCountConsoleLog = TRPCONFIG.Domain2.CPGdisplayIframeCountConsoleLog;
                            let threeframe = document.querySelector('#threeframe');
                            let count = 0;
                            threeframe.addEventListener('load', () => {
                                count++;

                                if (CPGdisplayIframeCountConsoleLog) {
                                    console.log('Iframe load count:', count, CPGIframeIntvlTimeout, CPGNoOfCallsForIntervalStart, CPGNoOfCallsForIntervalPaymentFound, CPGNoOfCallsForOTPerror);
                                }

                                if (count > CPGNoOfCallsForIntervalStart) {
                                    setTimeout(() => {
                                        if (count > CPGNoOfCallsForIntervalStart &&
                                            (count < CPGNoOfCallsForIntervalPaymentFound || count === CPGNoOfCallsForOTPerror)) {
                                            let close = document.querySelector('.threeds-wrapper-new .close');
                                            if (close) {
                                                document.querySelector('.threeds-wrapper-new .close').click();
                                            }
                                            count = 0;
                                        }
                                    }, CPGIframeIntvlTimeout);
                                }
                            });
                        }
                    }

                    let url = `/api2/payments/transactions/getcpgclienttoken?domainId=${domainId}&cardTypeId=${cardTypeId}&currencyCode=${currencyCode}&orderCode=${orderCode}`;
                    return fetch(url)
                        .then(res => res.json())
                        .then(data => {
                            let at = null;
                            if (data && data.AccessToken) {
                                at = data.AccessToken;
                            }
                            return at;
                        })
                        .catch(error => {
                            console.log('error', error);
                            return null;
                        });

                } catch (error) {
                    console.log('error', error);
                    return null;
                }
            }

            scope.$on('request3DSValidation', async function(ev, threedsData, mixpanelData = {}) {
                if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                    let threeframe = document.getElementById('threeframe');
                    threeframe.style.display = 'none';

                    setTimeout(() => {
                        threeframe.style.display = 'block';
                    }, 1000);

                    let secretOverlay = document.getElementById('secretOverlay');
                    secretOverlay.classList.remove('open');
                }

                /* we can't do this as long as this bug is in effect:
                //https://github.com/angular/angular.js/issues/3924
                if($sniffer.history) {
                    $window.history.pushState(null, '', $location.path());
                    $($window).on('popstate', back);
                }
                */
                if (!_.isEmpty(mixpanelData)) {
                    scope.mixpanelData = mixpanelData;
                    analytics.track('mixpanel', '3DS Started', mixpanelData);
                }

                const secureForm = angular.element(document.getElementById('threeform')).empty();
                secureForm.attr('action', threedsData.AcsUrl);
                secureForm.attr('target', 'threeframe');
                secureForm.attr('method', 'POST');
                secureForm.append(String.format(hidden, 'TermUrl', threedsData.TermUrl));
                secureForm.append(String.format(hidden, 'PaReq', threedsData.PaReq));
                secureForm.append(String.format(hidden, 'MD', threedsData.MD));
                if (TRPCONFIG.Domain2.UseCpgUpdate) {
                    let domainId = TRPCONFIG.Domain.DomainId;
                    let cardTypeId = TRPCONFIG.Domain.CardTypeId;
                    let currencyCode = TRPCONFIG.Domain.CurrencyCode;
                    let orderCode = threedsData.MD;

                    let authToken = await getAuth(domainId, cardTypeId, currencyCode, orderCode);

                    secureForm.append(String.format(hidden, 'token', authToken));
                }
                secureForm[0].submit();
            });
        }
    };
});
})();
